import { render, staticRenderFns } from "./client-types.vue?vue&type=template&id=35d0ac04&"
import script from "./client-types.vue?vue&type=script&lang=js&"
export * from "./client-types.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports